export { default } from './TabContext';
export * from './TabContext';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TabContext/index.js
// module id = 420
// module chunks = 2